

































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import publishObjectPath from '@/util/configRegistry';
import { performanceServer, siteManagementServer, doublePrevention } from '@/api/installServer';

@Component({
  components: {},
  mixins: [TableStripe],
})
export default class WorkOrderDetailsDialog extends Vue {
  visible: any = false;
  rowProp: any = {};
  loading: any = false;

  private basicForm: any = {
    projectList: [],
    envProjectList: [],
    sign: '',
  };
  private projectRadio: any = 'project';
  private finishStaffName: any = '';
  private finishStaffSignUrl: any = '';
  imgPath: any = publishObjectPath.imgPathWater;

  riskLevelClass(level: any) {
    return {
      level_normal: level == '低风险',
      level_general: level == '一般风险',
      level_more: level == '较大风险',
      level_major: level == '重大风险',
    };
  }
  pollutionLevelClass(level: any) {
    return {
      level_normal: level == 'Ⅳ级',
      level_general: level == 'Ⅲ级',
      level_more: level == 'Ⅱ级',
      level_major: level == 'Ⅰ级',
    };
  }

  showDialog(row: any) {
    this.loading = true;
    this.rowProp = row.id;
    this.visible = true;

    this.getDetailData();
  }

  created() {
    // this.getHiddenFormNum();
    // this.getCheckDetail();
  }

  private getDetailData() {
    doublePrevention.getHandyCheckDetail(this.rowProp).then((res: any) => {
      if (res.code === '200') {
        this.basicForm = res.data;
        if (res.data.sign) {
          this.getValidatorCode(res.data.sign);
        }
      }
    });
  }
  // 获取签名图片 根据签名id
  private getValidatorCode(data: any) {
    performanceServer.getValidatorCode(data).then((res: any) => {
      if (res.code === '200') {
        this.finishStaffSignUrl = res.data.signature;
        this.finishStaffName = res.data.name;
      }
    });
  }
  private imgPreview(e: any) {
    setTimeout(() => {
      const dom: any = document.getElementsByClassName('el-image-viewer__img');
      for (let i = 0; i < dom.length; i++) {
        dom[i].style.transform = 'scale(1) rotate(270deg)';
      }
    });
  }
}
